module.exports = "<div class=\"ssf-category\">\n    <div class=\"ssf-category__heading-container\">\n        <div>\n            <h1 class=\"ssf-category__heading\">{{title}}</h1>\n        </div>\n        <div class=\"ssf-category__buttons\">\n            <ng-content select=\"[section-buttons]\"></ng-content>\n        </div>\n    </div>\n\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/section/section.component.html
// module id = 657
// module chunks = 3